import { render, staticRenderFns } from "./dr-page-player.vue?vue&type=template&id=039e296b"
import script from "./dr-page-player.vue?vue&type=script&lang=js"
export * from "./dr-page-player.vue?vue&type=script&lang=js"
import style0 from "./dr-page-player.vue?vue&type=style&index=0&id=039e296b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports